<template>
  <v-date-picker
          v-model="model"
          mode="range"
          :max-date="maxDate"
          :key="currentLanguage"
          :select-attribute="selectDragAttribute"
          :drag-attribute="selectDragAttribute"
          @input="datePickerChanged">
    <button
            class="waves-effect waves-light btn-flat"
            style="color: deepskyblue; border: deepskyblue 1px solid; border-radius: 5px;
                display: inline-flex; align-items: center;
                box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.24), 0px 0px 2px rgba(0, 0, 0, 0.12);">
      {{ startDate }} &nbsp; <i class="material-icons">date_range</i> &nbsp; {{ endDate }}
    </button>
  </v-date-picker>
</template>
<script>
import moment from 'moment'
import {setupCalendar} from 'v-calendar'

export default {
  name: 'DatePicker',
  props: {
    value: {},
    maxDate: {}
  },
  data () {
    return {
      model: this.value
    }
  },
  methods: {
    datePickerChanged () {
      this.$emit('dateChanged', this.model)
    }
  },
  watch: {
    value () {
      this.model = this.value
    },
    model () {
      this.$emit('input', this.model)
    }
  },
  computed: {
    startDate () {
      return moment(this.model.start).format('DD-MM-YY')
    },
    endDate () {
      return moment(this.model.end).format('DD-MM-YY')
    },
    selectDragAttribute () {
      return {
        popover: {
          visibility: 'hidden'
        }
      }
    },
    currentLanguage () {
      setupCalendar({
        locale: this.locale
      })
      return this.locale
    },
    locale () {
      let locale = localStorage.getItem('locale') || 'en-GB'
      if (locale === 'ru-RU') { // this locale is used for Tennet
        locale = 'nl-NL'
      }
      return locale.substr(0, 2)
    }
  }
}
</script>
<style scoped>
  select {
    height: 2.5rem;
  }

  [type="checkbox"]:checked + span:not(.lever):before {
    height: 17px !important;
    width: 9px !important;
    top: 0px !important;
    left: 0px !important;
  }

  [type="checkbox"] + span:not(.lever) {
    font-size: 14px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/switch/DatePicker.vue